/* eslint-disable @typescript-eslint/no-explicit-any */
export const info = {
  description:
    'Votre espace personnel pour profiter des fonctionnalités avancées',
  connexion: 'Créer un compte',
  imageUrl: '',
};

export const checkSignedUser = (user: any) => {
  const information = {...info};
  if (user && user.data && user.data.utilisateur) {
    const nom = user.data.utilisateur.nom ? user.data.utilisateur.nom : '';
    const prenom = user.data.utilisateur.prenom
      ? user.data.utilisateur.prenom
      : '';
    const description = `${nom} ${prenom}`;
    const connexion = 'Déconnecter mon compte';
    const imageUrl = user.data.utilisateur.imageUrl
      ? user.data.utilisateur.imageUrl
      : '';
      information.description = description;
      information.connexion = connexion;
      information.imageUrl = imageUrl;
  }
  else{
    return {connected: false, data:{description:'', imageUrl:'', connexion:''}};
  }

  return {connected:true, data:information};
};
